"use strict";

exports.__esModule = true;
exports.ElementFontControlGroup = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _FontPicker = require("../../../Form/FontPicker");
var _FontSizePicker = require("../../../Form/FontSizePicker");
var _TextAlignmentPicker = require("../../../Form/TextAlignmentPicker");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Controls for changing font related properties of an element.
 */
var ElementFontControlGroup = exports.ElementFontControlGroup = /*#__PURE__*/function (_Component) {
  function ElementFontControlGroup() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(ElementFontControlGroup, _Component);
  var _proto = ElementFontControlGroup.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      elementEditor = _this$props.elementEditor,
      controlPaths = _this$props.controlPaths;
    var fontFamily = controlPaths.fontFamily,
      fontSize = controlPaths.fontSize,
      fontWeight = controlPaths.fontWeight,
      fontStyle = controlPaths.fontStyle,
      textDecoration = controlPaths.textDecoration,
      textAlignment = controlPaths.textAlignment;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.ButtonGroup, {
      large: true,
      minimal: true
    }, /*#__PURE__*/_react["default"].createElement(_FontPicker.FontPicker, {
      style: {
        width: 200
      },
      value: elementEditor.getProp(fontFamily, "fontFamily", ""),
      onChange: function onChange(value) {
        return fontFamily && elementEditor.setProp(fontFamily, "fontFamily", value);
      },
      disabled: !fontFamily
    }), /*#__PURE__*/_react["default"].createElement(_FontSizePicker.FontSizePicker, {
      style: {
        width: 120
      },
      value: elementEditor.getProp(fontSize, "fontSize", ""),
      onChange: function onChange(value) {
        return fontSize && elementEditor.setProp(fontSize, "fontSize", value);
      },
      disabled: !fontSize
    })), /*#__PURE__*/_react["default"].createElement(_core.ButtonGroup, {
      large: true,
      style: {
        marginLeft: "1rem"
      },
      minimal: true
    }, /*#__PURE__*/_react["default"].createElement(_core.Button, {
      icon: _icons.IconNames.BOLD,
      active: elementEditor.getProp(fontWeight, "fontWeight") === "bold",
      onClick: function onClick() {
        return fontWeight && elementEditor.setProp(fontWeight, "fontWeight", elementEditor.getProp(fontWeight, "fontWeight") === "bold" ? undefined : "bold");
      },
      disabled: !fontWeight
    }), /*#__PURE__*/_react["default"].createElement(_core.Button, {
      icon: _icons.IconNames.ITALIC,
      active: elementEditor.getProp(fontStyle, "fontStyle") === "italic",
      onClick: function onClick() {
        return fontStyle && elementEditor.setProp(fontStyle, "fontStyle", elementEditor.getProp(fontStyle, "fontStyle") === "italic" ? undefined : "italic");
      },
      disabled: !fontStyle
    }), /*#__PURE__*/_react["default"].createElement(_core.Button, {
      icon: _icons.IconNames.UNDERLINE,
      active: elementEditor.getProp(textDecoration, "textDecoration") === "underline",
      onClick: function onClick() {
        return textDecoration && elementEditor.setProp(textDecoration, "textDecoration", elementEditor.getProp(textDecoration, "textDecoration") === "underline" ? undefined : "underline");
      },
      disabled: !textDecoration
    }), /*#__PURE__*/_react["default"].createElement(_TextAlignmentPicker.TextAlignmentPicker, {
      value: elementEditor.getProp(textAlignment, "textAlignment", "center"),
      onChange: function onChange(value) {
        return textAlignment && elementEditor.setProp(textAlignment, "textAlignment", value);
      },
      disabled: !textAlignment
    })));
  };
  return ElementFontControlGroup;
}(_react.Component);